import type { AccountBase } from '@/models/AccountViewModel';
import { ClassificationIdNumber } from '@/utils/enums';

export function deriveIsAssetFromAccount(
  account: Partial<AccountBase> & { TopClassificationId?: number },
): boolean {
  return (
    account.IsAsset ??
    account.TopClassificationId === ClassificationIdNumber.ASSET
  );
}
